import { useQuery } from "@tanstack/react-query";
import { API } from "config";
import Moment from "moment";

const useDistributorsList = (
    page,
    term,
    region,
    stateId,
    cityId,
    condition,
    // period,
) =>
    useQuery({
        queryKey: [
            "distributors",
            page,
            term,
            region,
            stateId,
            cityId,
            condition,
            // period,
        ],
        queryFn: async () => {
            const params = new URLSearchParams({
                page,
                ...(term && { term }),
                ...(region && { region }),
                ...(stateId && { stateId }),
                ...(cityId && { cityId }),
                ...(condition && { condition }),
                // ...(period && period[0] && { start: Moment(period[0]).format('YYYY-MM-DD HH:mm:ss') }),
                // ...(period && period[1] && { end: Moment(period[1]).format('YYYY-MM-DD HH:mm:ss') }),
            });

            const { data } = await API.get(`/distributors/list?${params}`);
            return data;
        },
        staleTime: 1000 * 60 * 60,
        gcTime: 1000 * 60 * 60 * 24,
    });

export default useDistributorsList;